import { useTranslation } from 'react-i18next';
import classes from './LanguageToggle.module.css';

const languages = [
  { code: 'no', lang: 'nb', label: 'Norsk' },
  { code: 'en', lang: 'en', label: 'English' },
];

/** The language choice in the header of a public page. Each language is named in its own language. */
export const LanguageToggle = ({ onChange }: { onChange: (language: string) => void }) => {
  const { t, i18n } = useTranslation();

  return (
    <div role="group" aria-label={t('publicResults.language')} className={classes.group}>
      {languages.map(({ code, lang, label }) => (
        <button
          key={code}
          type="button"
          lang={lang}
          aria-pressed={i18n.language === code}
          className={classes.option}
          onClick={() => onChange(code)}
        >
          {label}
        </button>
      ))}
    </div>
  );
};
